import { UitzonderingComponent } from './uitzondering.component';
import { Directive } from '@angular/core';
import { FilterName } from '../../services/filter-name';

@Directive()
export abstract class UitzonderingPrestatieanalyseComponent extends UitzonderingComponent {
	override overrideDefault?: Partial<{ [name in FilterName]: any }> = undefined;
}
